<article class="overview-layout">
    <div class="paragraph paragraph--type--text paragraph--view-mode--default">
        <h1 translate="Cookiebeleid.h1"></h1>

        <h2 translate="Cookiebeleid.Waarom.header"></h2>

        <div [innerHTML]="getTranslatedBody('Cookiebeleid.Waarom.body') | async"></div>

        <h2 translate="Cookiebeleid.Hoe.header"></h2>

        <div [innerHTML]="getTranslatedBody('Cookiebeleid.Hoe.body') | async"></div>

        <h2 translate="Cookiebeleid.Wat.header"></h2>

        <div [innerHTML]="getTranslatedBody('Cookiebeleid.Wat.body') | async"></div>

        <h2 translate="Cookiebeleid.Welke.header"></h2>

        <div [innerHTML]="getTranslatedBody('Cookiebeleid.Welke.body') | async"></div>

        <h2 translate="Cookiebeleid.Lijst.header"></h2>

        <div #cookieLijst></div>

        <h2 translate="Cookiebeleid.Verantwoordelijke.header"></h2>

        <div [innerHTML]="getTranslatedBody('Cookiebeleid.Verantwoordelijke.body') | async"></div>

        <h2 translate="Cookiebeleid.Veranderlijk.header"></h2>

        <div [innerHTML]="getTranslatedBody('Cookiebeleid.Veranderlijk.body') | async"></div>

        <h2 translate="Cookiebeleid.Omgang.header"></h2>

        <div [innerHTML]="getTranslatedBody('Cookiebeleid.Omgang.body') | async"></div>

        <h2 translate="Cookiebeleid.Vragen.header"></h2>

        <div [innerHTML]="getTranslatedBody('Cookiebeleid.Vragen.body') | async"></div>
    </div>
</article>
